import React from 'react'
import {Dialog, DialogContent, IconButton} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import useStyles from 'pages/ProductOperationOrganization/Component/DialogRegistrationManualStyle'
import TableLogs from './TableLogs'

type DialogActiveProductProps = {
  open: boolean
  dataTable: {
    usageDateTime: number
    method: string
    usageId: string
    reason: string
  }[]
  onClose: () => void
  type: 'monthly' | 'bulk' | 'manual'
}

const DialogTableLogs = (props: DialogActiveProductProps) => {
  const {open, onClose, dataTable, type} = props
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='lg'
      className={classes.container}
    >
      <div className={classes.closeButtonWrap}>
        <IconButton
          color='secondary'
          aria-label='favorite'
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </div>
      <DialogContent className={classes.contentWrap}>
        <TableLogs dataTable={dataTable} type={type} />
      </DialogContent>
    </Dialog>
  )
}

export default DialogTableLogs
